import { css, styled } from '@mui/material'

export const ContentContainer = styled('div')`
  height: 100%;
  flex: 1;
  overflow: auto;
`

export const ContentDesktopContainer = styled('div')`
  height: 100%;
  flex: 1;
  overflow: auto;
`

export const FooterContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'extraBottomPadding' && prop !== 'removeBottomPadding',
})<{ extraBottomPadding?: boolean; removeBottomPadding?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  padding: ${({ theme }) => theme.spacing(2, 2, 0, 2)};
  ${({ removeBottomPadding, theme, extraBottomPadding }) =>
    !removeBottomPadding &&
    css`
      padding-bottom: calc(${extraBottomPadding ? theme.spacing(2) : theme.spacing(0.5)} + var(--ion-safe-area-bottom));
    `}

  margin-top: auto;
  bottom: 0;
`
